package tools

import androidx.compose.ui.text.input.*

fun String.norm(): String {
    return normalizeString(this)
}

expect fun normalizeString(input: String): String

fun Any.toTextFieldValue(): TextFieldValue {
    return TextFieldValue(toString())
}
